module.exports = __webpack_public_path__ + "img/eff05small.09b517ad.png";